import { useAlert } from '@/hooks';
import { AlertConfig } from '@/hooks/AlertContext';

type Props = {
  value: string;
  title?: string;
  errorTitle?: string;
  borderLeft?: AlertConfig['borderLeft'];
  bordered?: AlertConfig['bordered'];
  showIcon?: AlertConfig['showIcon'];
  bgType?: AlertConfig['bgType'];
  time?: number;
};

export const useClipboard = () => {
  const { showAlert } = useAlert();

  const copyToClipboard = async (props: Props) => {
    const {
      value,
      title,
      errorTitle,
      borderLeft = true,
      bordered = true,
      showIcon = true,
      bgType = 'secondary',
      time = 3500,
    } = props;

    if (!value) return;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = value;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
      }

      showAlert({
        title: title || `<b>${value}</b> copiado com sucesso`,
        bordered: bordered,
        borderLeft: borderLeft,
        showIcon: showIcon,
        theme: 'success',
        close: 'icon',
        bgType: bgType || 'secondary',
        time: time,
      });
    } catch (error) {
      showAlert({
        title: errorTitle || `Erro ao copiar <b>${value}</b>`,
        bordered: bordered,
        borderLeft: borderLeft,
        showIcon: showIcon,
        theme: 'danger',
        bgType: bgType || 'secondary',
        time: time,
      });
    }
  };

  return { copyToClipboard };
};
